import { LiveBlogEvents, SharingEvent } from '@news-mono/web-common'
import { EventPostV4DTO } from '@west-australian-newspapers/publication-types'
import React, { FC, useMemo } from 'react'
import { Logger } from 'typescript-log'
import { sortPostsDesc, useIsComponentOnScreen } from '../helpers'
import { LiveEventPost } from './LiveEventPost'
import { StyledLiveEventTimeline } from './LiveEventTimeline.styled'

export interface LiveEventTimelineProps {
    log: Logger
    adUnitPath: string
    posts: EventPostV4DTO[]
    eventTitle: string
    onEvent: (event: LiveBlogEvents | SharingEvent) => void
    triggerLazyLoad: VoidFunction
    divRef?: React.RefObject<HTMLDivElement>
}

export const LiveEventTimeline: FC<LiveEventTimelineProps> = ({
    posts,
    eventTitle,
    log,
    adUnitPath,
    triggerLazyLoad,
    onEvent,
    divRef,
}) => {
    const { componentRef } = useIsComponentOnScreen('0px', triggerLazyLoad)

    const sortedPosts: EventPostV4DTO[] = useMemo(
        () => sortPostsDesc(posts),
        [posts],
    )

    return (
        <StyledLiveEventTimeline ref={divRef}>
            {sortedPosts.map((post, index) => {
                return (
                    <LiveEventPost
                        key={post.id}
                        post={post}
                        log={log}
                        eventTitle={eventTitle}
                        adUnitPath={adUnitPath}
                        lazyLoadRef={
                            index === posts.length - 3
                                ? componentRef
                                : undefined
                        }
                        onEvent={onEvent}
                    />
                )
            })}
        </StyledLiveEventTimeline>
    )
}
